import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import { envAwarePost, envAwareFormSubmit } from "../../util/util";

export const editProfilePicture = createAsyncThunk(
  "editProfilePicture",
  async (payload) => envAwareFormSubmit({
      path: "api/users/api/",
      payload,
    })
);
export const editClientData = createAsyncThunk(
  "editClientData",
  async (payload) => envAwarePost("clientAddEditDeleteMobWeb/",payload)
);

//This function uses a different endpoint. Using it to update login and contact emails
export const editClientFieldData = createAsyncThunk(
  "editClientFieldData",
  async (payload) =>
    envAwarePost("profileMobWeb/",payload)
);

export const getClientProfileData = createAsyncThunk(
  "getClientProfileData",
  async (payload) => envAwarePost("clientListMobWeb.php",payload)
);

export const updateMeasurementSystem = createAsyncThunk(
  "updateMeasurementSystem",
  async (payload) => envAwarePost("api/user/api",{
    action: "updateMeasurementSystem",
    system: payload.system
  })
);

export const getUserMeasurementData = createAsyncThunk(
  "getUserMeasurementData", 
  async (payload) => envAwarePost("api/user/api.php",{
    action: "getUser",
  })
);






const profileSlice = createSlice({
  name: "profileSlice",
  initialState: {
    clientData: {},
    clientMeasurementSystem: "metric",
    measurementDataStatus: "idle",
  },
  reducers: {},
  extraReducers: {
    [editProfilePicture.rejected]: (state, action) => {
      // console.log(action);
    },
    [editProfilePicture.fulfilled]: (state, action) => {
      // console.log(action);
    },
    [editClientData.fulfilled]: (state, action) => {
      const fieldVar = Object.keys(action.meta.arg)[0]
      const valueVar = Object.values(action.meta.arg)[0]
      // console.log(fieldVar, valueVar);
    },
    [editClientFieldData.fulfilled]: (state, action) => {
      if(action.payload.data){
        const { field, value } = action.payload.data;
        if (field == "user_id") {
          state.clientData[0].clientUserID = value
        } else if (field =="user_email") {
          state.clientData[0].clientDisplayName = value
        } else if (field =="phone") {
          state.clientData[0].clientPhone = value
        }
      }
      // console.log(action);
    },
    [getClientProfileData.fulfilled]: (state, action) => {
      // console.log(action);
      state.clientData = action.payload.data;
    },
  
    [getUserMeasurementData.pending] : (state, action) => {
      state.measurementDataStatus="fetching"
    },
    [getUserMeasurementData.fulfilled] : (state, action) => {
      // console.log(action);
      state.measurementDataStatus="idle"
      state.clientMeasurementSystem = action.payload.data.measurement_system;
    },
    [getUserMeasurementData.rejected] : (state, action) => {
      state.measurementDataStatus="idle"
    },
  },
});

export default profileSlice.reducer;
